export { TdMarkdownComponent } from './markdown.component';
export { CovalentMarkdownModule } from './markdown.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/markdown/index.js
// module id = ../../../../@covalent/markdown/index.js
// module chunks = 4